module.exports = __webpack_public_path__ + "img/packages/bot_row_stb.8be89c.png";